import { eventsRequest } from '../../utils/eventsRequest';

export const getPaymentMethodAcceptedCreditCardBrands = async (locationUUID: string): Promise<any> => {
  try {
    const response = await eventsRequest(
      `/payment/method/accepted-credit-card-brands?locationId=${locationUUID}`,
      'get',
    );

    if (response.status === 200) {
      return response.data as any;
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const methodDefaultValidateBrands = async (locationUUID: string): Promise<any> => {
  try {
    const response = await eventsRequest(
      `/payment/method/default/validate?locationId=${locationUUID}`,
      'get',
    );

    if (response.status === 200) {
      return response.data as any;
    } else {
      return false;
    }
  } catch (error) {
    console.error(error);
    return false;
  }
};
